import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import {
  kneeIcon,
  hipIcon,
  spineIcon,
  serviceCardWaves,
} from "../assets/appImages";
import ServiceStats from "../components/ServiceStats";
import LatestNews from "../components/LatestNews";
import { fetchBlogsPage } from "../api/blogsPage";
import { fetchServicesPage } from "../api/servicesPage";
import { useHomePage } from "../context/HomePageContext";

const FALLBACK_ICONS = [kneeIcon, hipIcon, spineIcon];

const ServiceCard = ({ id, title, description, icon }) => (
  <article className="relative flex h-full min-h-[380px] flex-col overflow-hidden rounded-[18px] bg-white p-6 shadow-[0_10px_32px_rgba(118,9,130,0.08)] md:min-h-[400px] md:p-7 lg:p-8">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-6 -top-4 h-[200px] w-[240px] mix-blend-multiply opacity-[0.14] invert md:h-[220px] md:w-[260px]"
      style={{
        backgroundImage: `url(${serviceCardWaves})`,
        backgroundSize: "cover",
        backgroundPosition: "top right",
        backgroundRepeat: "no-repeat",
      }}
    />

    <div className="relative flex h-[80px] w-[80px] shrink-0 items-center justify-center rounded-[10px] border border-[#E4E4E4] bg-white">
      <img src={icon} alt="" aria-hidden="true" className="h-[80px] w-[80px] object-contain" />
    </div>

    <h3 className="relative mt-6 text-[18px] font-bold text-brand-purple md:mt-7 md:text-[20px]">
      {title}
    </h3>
    <div
      className="relative mt-4 flex-1 text-[14px] leading-[1.8] text-[#555555]"
      dangerouslySetInnerHTML={{ __html: description || "" }}
    />

    <Link
      to={`/services/${id}`}
      className="relative inline-flex w-fit items-center gap-3 rounded-md bg-[#E1E2F6] py-1.5 pl-5 pr-1.5 transition-opacity hover:opacity-90"
    >
      <span className="text-[14px] font-semibold text-brand-purple">View More</span>
      <span className="flex h-8 w-8 items-center justify-center rounded-md bg-white text-brand-purple">
        <FaChevronRight className="text-[11px]" aria-hidden="true" />
      </span>
    </Link>
  </article>
);

const ServicesPage = () => {
  const { setContact } = useHomePage();
  const [services, setServices] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadServicesPage = async () => {
      try {
        const [servicesData, blogsData] = await Promise.all([
          fetchServicesPage(),
          fetchBlogsPage(),
        ]);
        if (!isMounted) return;
        setServices(servicesData.services);
        setExperiences(servicesData.experiences);
        setBlogs(blogsData.blogs || []);
        if (servicesData.contact) {
          setContact(servicesData.contact);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadServicesPage();

    return () => {
      isMounted = false;
    };
  }, [setContact]);

  return (
    <>
      {services.length > 0 && (
        <section className="bg-white pb-14 pt-10 md:pb-16 md:pt-12 lg:pb-20">
          <div className="mx-auto max-w-7xl px-4 md:px-8">
            <div className="grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
              {services.map((item, index) => (
                <ServiceCard
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  description={item.description}
                  icon={item.icon || FALLBACK_ICONS[index % FALLBACK_ICONS.length]}
                />
              ))}
            </div>
          </div>
        </section>
      )}

      <ServiceStats experiences={experiences} />
      <LatestNews newsItems={blogs} />
    </>
  );
};

export default ServicesPage;
